export const FooterMenu = [
  {
    items: [
      {
        label: '일반 뉴스',
        url: 'https://kr.benzinga.com/news',
      },
      {
        label: '한국',
        url: 'https://kr.benzinga.com/news/korea/',
      },
      {
        label: '미국 뉴스',
        url: 'https://kr.benzinga.com/news/usa/',
      },
      {
        label: '아시아 뉴스',
        url: 'https://kr.benzinga.com/news/global/asia/',
      },
      {
        label: '유럽 뉴스',
        url: 'https://kr.benzinga.com/news/global/europe/',
      },
    ],
    label: '뉴스',
  },
  {
    items: [
      {
        label: '기고하기',
        url: 'https://kr.benzinga.com/contribute-to-benzinga/',
      },
      {
        label: '라이선스 및 신디케이션',
        url: 'https://kr.benzinga.com/benzinga-korea/',
      },
      {
        label: '스폰서 컨텐츠',
        url: 'https://kr.benzinga.com/benzinga-korea/',
      },
      {
        label: '광고 게제',
        url: 'https://kr.benzinga.com/benzinga-korea/',
      },
      {
        label: '미디어 키트 요청',
        url: 'https://kr.benzinga.com/benzinga-korea/',
      },
      {
        label: '회사 소개',
        url: 'https://kr.benzinga.com/benzinga-korea/',
      },
    ],
    label: '파트너 / 기고자',
  },
  {
    items: [
      {
        label: '벤징가 미국',
        url: 'https://kr.benzinga.com/www.benzinga.com',
      },
      {
        label: '벤징가 코리아',
        url: 'https://kr.benzinga.com/',
      },
      {
        label: '벤징가 일본',
        url: 'https://jp.benzinga.com/',
      },
      {
        label: '벤징가 이탈리아',
        url: 'https://it.benzinga.com/',
      },
      {
        label: '벤징가 스페인',
        url: 'https://es.benzinga.com/',
      },
      {
        label: '벤징가 인도',
        url: 'https://in.benzinga.com/',
      },
    ],
    label: '벤징가 글로벌',
  },
];

export const FooterCopyRightLinks = [
  {
    label: '개인정보 보호 정책',
    url: 'https://kr.benzinga.com/privacy-policy/',
  },
  {
    label: '이용 약관',
    url: '#',
  },
  {
    label: '접근성',
    url: '#',
  },
];
